function apiUrl(path: string) {
  const base = import.meta.env.BASE_URL.replace(/\/?$/, "/");
  return `${base}${path.replace(/^\//, "")}`;
}

export function initContact() {
  const form = document.querySelector<HTMLFormElement>("#contact-form");
  const message = document.querySelector("#form-message");
  if (!form || !message) return;

  form.addEventListener("submit", async (event) => {
    event.preventDefault();
    const body = {
      name: (form.querySelector("#name") as HTMLInputElement).value.trim(),
      email: (form.querySelector("#email") as HTMLInputElement).value.trim(),
      message: (form.querySelector("#message") as HTMLTextAreaElement).value.trim(),
    };
    message.textContent = "Sending…";
    try {
      const response = await fetch(apiUrl("api/contact.php"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });
      const data = (await response.json()) as { ok?: boolean; error?: string };
      if (!response.ok || !data.ok) {
        message.textContent = data.error || "Could not send. Email hello@bambooh2c.com.";
        return;
      }
      message.textContent = "Thanks — your message is on its way.";
      form.reset();
    } catch {
      message.textContent = "Could not send. Email hello@bambooh2c.com.";
    }
  });
}
